// extracted by mini-css-extract-plugin
export default {"section":"Search_section__M6bOd","section__title":"Search_section__title__PNIlF"};